<template>
  <div class="container">
    <h1>My Account</h1>
    <div class="container mt-4">
      <h2>Personal Info</h2>
      <div class="form-row">
        <div class="col-sm-4">
          <label class="control-label">Email Address</label>
        </div>
        <div class="col-sm-8">
          {{email}}
        </div>
      </div>
      <div v-if="usageCount !== undefined">
        <h2 class="mt-4">Usage</h2>
        <p>You have used LevelFi to score {{ usageCount }} times this month.</p>
      </div>
    </div>
  </div>
</template>

<script>
import DateFn from "date-fns";

import API from "@/services/api";

export default {
  data() {
    return {
      usageCount: undefined
    };
  },
  subscriptions: {
    email: API.LoggedInEmail
  },
  async mounted() {
    // Boot to login if not logged in
    if (!API.token) {
      this.$router.replace("/login");
    }
    const monthStart = DateFn.format(
      DateFn.startOfMonth(new Date()),
      "YYYY-MM-DD"
    );
    const tomorrow = DateFn.format(
      DateFn.startOfTomorrow(new Date()),
      "YYYY-MM-DD"
    );
    const result = await API.QueryUsage(monthStart, tomorrow);
    if (result.data && result.data.data) {
      // Add all data counts together
      let totalCount = 0;
      for (const point of result.data.data) {
        if (point.count) totalCount += point.count;
      }
      this.usageCount = totalCount;
    }
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MyAccount.vue